export enum StorageKeys {
  AccessToken = '@AccessToken',
}
